import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { AbcPopupComponent, _AbcButtonComponent, _AbcScrollViewComponent } from '@barthauer/abc/ui-components';
import { DxButtonModule, DxDataGridModule, DxFormModule, DxTemplateModule } from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import { Subscription } from 'rxjs';
import { AppService } from '../../services/app.service';
import { DataService } from '../../services/data.service';
import { PermessionService } from '../../services/permession.service';
import { UserSettingsComponent } from '../user-settings/user-settings.component';

@Component({
  selector: 'app-user-right-popup',
  templateUrl: './user-right-popup.component.html',
  styleUrls: ['./user-right-popup.component.scss'],
  standalone: true,

  imports: [
    CommonModule,
    FlexLayoutModule,
    _AbcButtonComponent,
    AbcPopupComponent,
    DxDataGridModule,
    DxTemplateModule,
    DxFormModule,
    AbcPopupComponent,
    _AbcButtonComponent,
    _AbcButtonComponent,
    FormsModule,
    UserSettingsComponent,
    DxiItemModule,
    DxButtonModule,
    DxiItemModule,
    _AbcScrollViewComponent,
    DxDataGridModule,
  ],
})
export class UserRightPopupComponent implements OnInit, OnDestroy {
  @ViewChild('userPopup', { static: false }) userPopup: AbcPopupComponent;
  @ViewChild('settings', { static: false }) settings: UserSettingsComponent;
  @Input() loadPopup: boolean;
  @Input() public roleId: string;
  public title: string = '';
  private subscriptions: Subscription[] = [];
  public updateButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Update'),
    useSubmitBehavior: true,
  };
  constructor(
    public dataService: DataService,
    public appService: AppService,
    public permessionService: PermessionService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.permessionService.getRole().subscribe({
        next: (role) => {
          this.title = role?.Description
            ? `${this.dataService.res('Ubt-User-Rights')}: ${role.Description}`
            : this.dataService.res('Ubt-Settings-Popup');
        },
        error: (error) => {
          this.title = this.dataService.res('Ubt-Settings-Popup');
        },
      })
    );

    if (this.loadPopup) this.openUserPopup();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  showPopup() {
    this.settings.getOtherLanguagePermissionList();
  }

  public openUserPopup() {
    if (this.userPopup) {
      this.userPopup.instance.show();
    }
  }

  public onPopupShown(e): void {
    e.component.content().parentElement.parentElement.classList.add('custom-popup');
  }

  public saveChanges() {
    this.settings.saveChanges();
    this.closePopUp();
  }

  public closePopUp() {
    this.userPopup.instance.hide();
    this.permessionService.setRole(undefined);
    this.settings.arrayOfPermessions = [];
    this.appService.showLoader(false);
  }
}
